// extracted by mini-css-extract-plugin
export var contentBody = "_bh-9";
export var headerImage = "_bh-2";
export var imageButton = "_bh-7";
export var imageButtonIcon = "_bh-8";
export var imageHeader = "_bh-4";
export var imageHeaderText = "_bh-5";
export var imageOverlay = "_bh-3";
export var imageTitle = "_bh-6";
export var imageWrapper = "_bh-1";
export var taskList = "_bh-a";
export var widget = "_bh-0";